<template>
  <div>
    <AppSection
      id="test-connectivity"
      type="section"
      :title="$getConst.pages.connectivity_test.connectivity_test_page_title"
      :is-section-loading="is_loading"
    >

      <b-row class="justify-content-center py-5">

        <template v-for="option in options">
          <b-col v-if="option.is_shown" xl="3" lg="4" md="4" sm="6" class="pb-4">
            <b-overlay :show="option.isLoading || option.success !== null" class="h-100" opacity="1">
              <AppPageOptionBox
                v-if="!hasWritePermission"
                @onClick="onSubmit(option)" :text="option.text" :icon="option.icon"/>

              <template #overlay>
                <div class="text-center text-secondary">
                  <div v-if="option.success === null">
                    <AppSpinner size="3" class="mx-auto mb-3"/>
                    <h5 class="mb-0 font-weight-bold">{{this.$t(this.$getConst.pages.alerts.please_wait)}}</h5>
                  </div>
                  <AppSuccessCheckAnimation v-else-if="option.success === true"/>
                  <AppErrorAnimation v-else-if="option.success === false"/>
                </div>
              </template>
            </b-overlay>
          </b-col>
        </template>

      </b-row>

    </AppSection>
    <AppSection
      id="status-history"
      type="section"
      :title="$getConst.pages.nav_status_history.nav_status_history_title"
      :is-section-loading="is_loading"
      v-if="!is_loading && scope.is_timesheets_enabled"
    >
      <NavStatusHistory :scope_id="scope_id"/>
    </AppSection>
  </div>
</template>

<script>
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppPageOptionBox from "../../../../components/common/utils/AppPageOptionBox";
  import AppSpinner from "../../../../components/common/utils/AppSpinner";
  import {checkNavStatus, getOneScope} from "../../../../api/scopes.api";
  import {testScopeMailCredentials} from "../../../../api/mailCredentials.api";
  import AppSuccessCheckAnimation from "../../../../components/common/utils/AppSuccessCheckAnimation";
  import AppErrorAnimation from "../../../../components/common/utils/AppErrorAnimation";
  import {snotifyConfig} from "../../../../shared/constants/snotify";
  import NavStatusHistory from "./NavStatusHistory";
  export default {
    name: "index",
    components: {NavStatusHistory, AppErrorAnimation, AppSuccessCheckAnimation, AppSpinner, AppPageOptionBox, AppSection},
    props: {
      scope_id: null
    },
    data() {
      return {

        hasWritePermission: !this.hasAnyOfPermissions(
          [
            this.$getConst.permissions.readScope, this.$getConst.permissions.readScopeMailCredentials
          ]
        ),
        scope: null,
        is_loading:false
      }
    },
    computed: {
      options() {
        if (!this.is_loading) {
          return [
            {destination: "NAV", text: this.$t(this.$getConst.pages.connectivity_test.test_nav_status), icon: this.$getConst.svgIcons.wifi, isLoading: false, success: null, is_shown: this.scope.is_timesheets_enabled},
            {destination: "SMTP", text: this.$t(this.$getConst.pages.connectivity_test.test_smtp_status), icon: this.$getConst.svgIcons.wifi, isLoading: false, success: null, is_shown: true},
          ]
        }
      }
    },
    methods: {
      onSubmit(option) {
        option.isLoading = true;
        switch (option.destination) {
          case "NAV":
            this.testNav(option);
            break;
          case "SMTP":
            this.testSMTP(option);
            break;
          case "JOBS":
            this. monitoringJobs(option);
            break;
          default:
            break;
        }
      },
      testNav(option) {
        this.$snotify.async(
          this.$t(this.$getConst.pages.connectivity_test.nav_request_sending),
          this.$t(this.$getConst.pages.alerts.please_wait),
          () => new Promise((resolve, reject) => {
            checkNavStatus(this.scope_id).then(
              (response) => {
                option.isLoading = false;
                  this.setAnimatedIcon(option, true);
                  resolve({
                    title: this.$t(this.$getConst.pages.alerts.success),
                    body: this.$t(this.$getConst.pages.connectivity_test.nav_success_message),
                    config: snotifyConfig,
                  })

              },
              (error) => {
                option.isLoading = false;
                this.setAnimatedIcon(option, false);

                let msg = error.response.data.error;

                if (error.response.data.error === 'B17_invalid_NAV_credentials') {
                  msg = this.$t(this.$getConst.pages.alerts.invalid_NAV_credentials);
                } else if (error.response.data.error === 'B199_no_response') {
                  msg = this.$t(this.$getConst.pages.alerts.nav_endpoint_not_accessible);
                }

                reject({
                  title: this.$t(this.$getConst.pages.alerts.error),
                  body: msg,
                  config: snotifyConfig
                });
              }
            )
          })
        )
      },
      testSMTP(option) {
        this.$snotify.async(
          this.$t(this.$getConst.pages.connectivity_test.smtp_request_sending),
          this.$t(this.$getConst.pages.alerts.please_wait),
          () => new Promise((resolve, reject) => {
            testScopeMailCredentials(this.scope_id).then(
              () => {
                option.isLoading = false;
                this.setAnimatedIcon(option, true);
                resolve({
                  title: this.$t(this.$getConst.pages.alerts.success),
                  body: this.$t(this.$getConst.pages.connectivity_test.smtp_success_message),
                  config: snotifyConfig,
                })
              },
              () => {
                option.isLoading = false;
                this.setAnimatedIcon(option, false);
                reject({
                  title: this.$t(this.$getConst.pages.alerts.error),
                  body: this.$t(this.$getConst.pages.connectivity_test.smtp_failure_message),
                  config: snotifyConfig
                })
              }
            )
          })
        )
      },
      setAnimatedIcon(option, isSuccess) {
        option.success = isSuccess;
        setTimeout(function(){ option.success = null; }, 5000);
      },
      monitoringJobs(option){
        this.$router.push({name: this.$getConst.routesNames.administration.monitoringJobs});
      },
      getScope() {
        this.is_loading = true;
        getOneScope(this.scope_id).then(
          response => {
            this.scope = response.data;
            this.is_loading = false;
          },
          error => {
            this.handleApiError(error);
            this.is_loading = false;
          }
        )
      }
    },
    created() {
      this.getScope();
    }
  }
</script>

<style scoped>
  .b-overlay {
    margin: 0 !important;
  }
</style>
